import { Component, OnInit, ElementRef, Input } from '@angular/core';
import echarts from 'echarts';
import { DatePipe } from '@angular/common';
import { format, subDays, differenceInCalendarDays } from 'date-fns';
import { _HttpClient } from '@delon/theme';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../../shared/constant/interface';

@Component({
  selector: 'app-video-publish-frequency',
  templateUrl: './video-publish-frequency.component.html',
  styleUrls: ['./video-publish-frequency.component.less'],
})
export class VideoPublishFrequencyComponent implements OnInit {
  constructor(private el: ElementRef, private datePipe: DatePipe, private http: _HttpClient, private dialogService: DialogService) {}

static NAME = 'icc-msg-social-video-publish';

  // 时间选择器选择时间有误
  isRangeError: boolean;
  validateRange = {
    errorKey: '',
    errorList: [
      {
        key: 'max-range-error',
        value: '最大跨度为31天',
      },
      {
        key: 'min-range-error',
        value: '最小跨度为7天',
      },
    ],
  };

  searchOptions = {
    start: subDays(new Date(), 7),
    end: subDays(new Date(), 1),
  };

  postParams = {
    channelId: 0,
    start: format(subDays(new Date(), 7), 'yyyyMMdd'),
    end: format(subDays(new Date(), 1), 'yyyyMMdd'),
  };

  dataSource: any;

  @Input() channelId: number;

  // 图谱实例
  chartIns: any;
  // 数据源
  @Input() dateList: Array<string>;
  @Input() countList: Array<number>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  /* 查询时间变更更新趋势数据 */
  handleDateChange() {
    if (this.selectDate()) {
      if (this.chartIns) {
        this.chartIns.dispose();
        this.chartIns = null;
      }
      window.removeEventListener('resize', this.resizeCharts);
      this.search();
    } else {
      this.dataSource = null;
    }
  }

  search() {
    this.postParams.start = format(this.searchOptions.start, 'yyyyMMdd');
    this.postParams.end = format(this.searchOptions.end, 'yyyyMMdd');
    this.http.post(URLS.fetchTikTokVideoReleaseFrequency.url, this.postParams).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length > 0) {
        this.dataSource = res.data;
        setTimeout(() => {
          this.formatData(this.dataSource);
          this.createLineChart('chart-el');
        }, 100);
      } else {
        this.dateList = [];
        this.countList = [];
      }
    });
  }

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) > -1 || differenceInCalendarDays(current, new Date()) < -730;
  };

  selectDate() {
    const selectRange = differenceInCalendarDays(this.searchOptions.end, this.searchOptions.start);
    let errorKey = selectRange > 30 ? 'max-range-error' : selectRange < 6 ? 'min-range-error' : '';
    if (errorKey) {
      const filterErrors = this.validateRange.errorList.filter(item => item.key === errorKey);
      if (filterErrors.length) {
        this.dialogService.notification.error('查询条件', filterErrors[0].value);
        this.validateRange.errorKey = filterErrors[0].key;
        this.isRangeError = true;
      }
      return false;
    } else {
      this.isRangeError = false;
      this.validateRange.errorKey = '';
    }
    return true;
  }
  ngOnInit() {
    this.postParams.channelId = Number(this.channelId);
    this.http.post(URLS.fetchTikTokVideoReleaseFrequency.url, this.postParams).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length > 0) {
        this.dataSource = res.data;
        setTimeout(() => {
          this.formatData(this.dataSource);
          this.createLineChart('chart-el');
        }, 100);
      } else {
        this.dataSource = null;
      }
      window.addEventListener('resize', this.resizeCharts);
    });
  }

  formatData(data) {
    const dateList = [];
    const countList = [];
    data.forEach(item => {
      dateList.push(this.formatDisplayDate(item.postTime));
      countList.push({
        value: item.value,
      });
    });
    this.dateList = dateList;
    this.countList = countList;
  }

  // 格式化显示时期 20200801 -> 2020.08.01
  formatDisplayDate(date) {
    if (typeof date === 'string') {
      let year = date.slice(0, 4);
      let month = date.slice(4, 6);
      let day = date.slice(6);
      return year + '.' + month + '.' + day;
    } else {
      date = date + '';
      let year = date.slice(0, 4);
      let month = date.slice(4, 6);
      let day = date.slice(6);
      return year + '.' + month + '.' + day;
    }
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const axisLabel: any = {
      textStyle: {
        color: '#B9C0D6',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.dateList.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 0;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        show: false,
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.dateList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#bec4d7', //更改坐标轴文字颜色
            },
          },
        },
      ],
      yAxis: [
        {
          name: '单位:个',
          minInterval: 1,
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B9C0D6',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B9C0D6',
            },
            formatter: '{value} ',
          },
        },
        {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
        },
      ],
      series: [
        {
          name: '视频发布频率',
          type: 'bar',
          symbolSize: 1,
          barWidth: 40, // 柱体宽度
          itemStyle: {
            normal: {
              color: 'rgb(0,206,158)',
            },
          },
          data: this.countList,
        },
      ],
    });
  }
}
